import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import ScrollToTop from "../../components/scroll-to-top";

import heroBackground from "../../assets/images/hero/pages.jpg"; // Ensure this path is correct
// import about1 from "../../assets/images/ab3.jpg";
// import about2 from "../../assets/images/ab4.jpg";
// import about3 from "../../assets/images/ab1.jpg";

import { handleGetLanguage } from "../../utils/languageStorage";
import { FaFacebookMessenger } from "react-icons/fa";

export default function DeliveryRules() {
    const language = handleGetLanguage();

    return (
        <>
            <Navbar navClass="defaultscroll is-sticky" navlight={true} />

            {/* Hero Section */}
            <section
                className="relative table w-full py-24 lg:py-44 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${heroBackground})` }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-black opacity-60 md:opacity-70"></div>

                {/* Content */}
                <div className="container relative z-10">
                    <div className="text-center mt-12">
                        <h3 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-white tracking-wide">
                            {language === "en" ? "Delivery Rules" : "მიწოდების წესები"}
                        </h3>
                    </div>
                </div>

                {/* Breadcrumbs */}
                <div className="absolute bottom-5 left-0 right-0 z-10 px-3">
                    <ul className="flex justify-center items-center space-x-2 md:space-x-4">
                        <li>
                            <Link
                                to="/"
                                className="uppercase text-sm md:text-base font-bold text-white/50 hover:text-white transition duration-300"
                            >
                                ONLYBRANDS
                            </Link>
                        </li>
                        <li>
                            <i className="mdi mdi-chevron-right text-white/50"></i>
                        </li>
                        <li
                            className="uppercase text-sm md:text-base font-bold text-white"
                            aria-current="page"
                        >
                            {language === "en" ? "Rules" : "წესები"}
                        </li>
                    </ul>
                </div>
            </section>
<br />
            {/* Content Section */}
            <section className="py-16 md:py-24 px-4 bg-gray-50 dark:bg-black">
                <div className="container mx-auto">
                    <div className="prose max-w-none text-gray-800 dark:text-white">
                        {/* Section 6 */}
                        <p className="text-lg md:text-xl">
                            {language === "en"
                                ? "Order preparation for shipment is carried out as follows:"
                                : "შეკვეთების გასაგზავნად გამზადება განხორციელდება:"}
                        </p>
                        <ul className="list-disc list-inside space-y-2 text-lg md:text-xl">
                            <li>
                                {language === "en"
                                    ? "Orders received before 11:00 within Tbilisi are shipped the same day."
                                    : "• 11:00 საათამდე მიღებული შეკვეთები თბილისის ფარგლებში გაიგზავნება იმავე დღეს"}
                            </li>
                            <li>
                                {language === "en"
                                    ? "Orders received after 11:00 are shipped the next day."
                                    : "• 11:00 საათის შემდეგ მიღებული შეკვეთები გაიგზავნება მომდევნო დღეს."}
                            </li>
                            <li>
                                {language === "en"
                                    ? "Orders placed on Sunday will be shipped on Monday."
                                    : "• კვირას განთავსებული შეკვეთები გაიგზავნება ორშაბათს"}
                            </li>
                        </ul>
                        <p className="text-lg md:text-xl">
                            {language === "en"
                                ? "Delivery service time for regions is set at 2 to 3 business days. Orders are delivered from Monday to Saturday. Delivery is not available on Sundays."
                                : "რეგიონებისთვის მიწოდების სერვისის დრო განსაზღვრულია 2 დან 3 სამუშაო დღემდე. შეკვეთის მიწოდება ხორციელდება ორშაბათიდან შაბათის ჩათვლით. კვირა დღეს მიწოდება არ ხორციელდება."}
                        </p>
                        <p className="text-lg md:text-xl">
                            {language === "en"
                                ? "Delivery is free across Georgia and courier service costs are covered by the company."
                                : "საქართველოს მასშტაბით მიწოდება არის უფასო და საკურიერო მომსახურების ხარჯებს ანაზღაურებს კომპანია."}
                        </p>

                    </div>
                </div>
            </section>
            

            <Footer />
            <ScrollToTop />
        </>
    );
}
